<div mat-dialog-title class="dialog-header">
  <h2>T.C. Vista Calendario:</h2>
  <mat-form-field appearance="outline" class="selector-field">
    <mat-select [formControl]="dateCtrl">
      @for (dateOption of dateOptions; track dateOption.value) {
        <mat-option [value]="dateOption.value">
          {{ dateOption.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<mat-dialog-content class="dialog-content">
  <div class="calendar-grid" *ngIf="!isLoadingMonth">
    @for (dayData of daysInMonth; track dayData.day) {
      <div
        class="day-card"
        [class.day-card--active]="isCurrentDay(dayData.day)"
        [class.day-card--disabled]="!dayData.hasData"
      >
        <div class="day-left">
          <span class="day-number">{{ dayData.day | number: '2.0-0' }}</span>
          <span class="day-name">{{ dayData.dayName }}</span>
        </div>
        <div class="day-divider"></div>
        @if (dayData.hasData) {
          <div class="day-rates">
            <div class="rate-row">
              <span class="rate-label">Compra:</span>
              <span class="rate-value">S/ {{ dayData.buy | number: '1.5-5' }}</span>
            </div>
            <div class="rate-row">
              <span class="rate-label">Venta:</span>
              <span class="rate-value">S/ {{ dayData.sell | number: '1.5-5' }}</span>
            </div>
          </div>
        } @else {
          <div class="day-rates">
            <div class="rate-row">
              <span class="rate-label">Compra:</span>
              <span class="rate-value">No registrado</span>
            </div>
            <div class="rate-row">
              <span class="rate-label">Venta:</span>
              <span class="rate-value">No registrado</span>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="calendar-loading" *ngIf="isLoadingMonth">
    <div class="loading-container">
      <mat-spinner diameter="60"></mat-spinner>
      <div class="loading-texts">
        <p class="loading-text">Cargando información del mes de {{ selectedMonthName }}.</p>
        <p class="loading-text">Esto puede tomar unos segundos...</p>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-stroked-button color="primary" (click)="close()">Cerrar</button>
</mat-dialog-actions>
